import{createContext}from"react";import noop from"lodash/noop";export var BurgerMenuContext=createContext({closeMenu:noop});